import BaseCollection from '@/collections/BaseCollection'

/**
 * Results service base collection class
 */
export default class ResultsServiceCollection extends BaseCollection {
  // Route configuration
  privateRoutes () {
    const model = (new (this.model())())
    return {
      fetch: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + model.modelName()
    }
  }
}
